export const OrderDocumentOutputType = {
	none: 0,
	loading: 1,
	unloading: 2,
};
